import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';        
import 'bootstrap-icons/font/bootstrap-icons.css';
import './css/bootstrap-override.css';


// TODO: remove boostrap unused css files

import './css/App.css';
import './fonts/appFonts.css';
import './css/index.css'; 


import { UserProvider } from './contexts/cognito/cognito-provider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <UserProvider>
      <App />
    </UserProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//
reportWebVitals();
